// ----------------------------------------------------------------------
export var Dialog = function Dialog(_ref) {
  var theme = _ref.theme;
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          boxShadow: theme.shadows[25].z24,
          '&.MuiPaper-rounded': {
            borderRadius: theme.shape.borderRadius
          },
          '@media (max-width: 600px)': {
            margin: 0
          }
        },
        paperFullWidth: {
          '@media (max-width: 600px)': {
            width: 'calc(100% - 48px)'
          }
        },
        paperFullScreen: {
          width: 'calc(100% - 48px)',
          height: 'calc(100% - 48px)'
        },
        scrollPaper: {
          '@media (min-width: 768px)': {
            alignItems: 'flex-start',
            position: 'relative',
            top: '150px'
          },
          '@media (max-height: 800px)': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            top: 'auto'
          }
        },
        paperScrollBody: {
          '@media (min-width: 768px)': {
            verticalAlign: 'top',
            top: '150px'
          },
          '@media (max-height: 800px)': {
            verticalAlign: 'middle'
          }
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: 24,
          paddingBottom: 0
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: 24
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        spacing: {
          padding: 24,
          '&> :not(:first-child)': {
            marginLeft: 12
          }
        }
      }
    }
  };
};